import { get, post, del } from '../request';

export async function fetchMasterList(
  { equityfinderService },
  authenticationToken,
  { propertyId, year },
) {
  const url = `${equityfinderService}/equityfinder/property/masterlist/${propertyId}?year=${year}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function addMaster(
  { equityfinderService },
  authenticationToken,
  { propertyId, compPropID },
) {
  const url = `${equityfinderService}/equityfinder/property/masterlist/${propertyId}`;
  const { body } = await post(authenticationToken, url, { compPropID });
  return body;
}

export async function copyMaster(
  { equityfinderService },
  authenticationToken,
  { propertyId, compPropID, year },
) {
  const url = `${equityfinderService}/equityfinder/property/masterlist/${propertyId}/copyversion`;
  const { body } = await post(authenticationToken, url, {
    propID: compPropID,
    year,
  });
  return body;
}

export async function removeMaster(
  { equityfinderService },
  authenticationToken,
  { masterId },
) {
  const url = `${equityfinderService}/equityfinder/property/master/${masterId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function masterCompPropertiesSelect(
  { equityfinderService },
  authenticationToken,
  { propertyId, propertyIds },
) {
  const url = `${equityfinderService}/equityfinder/property/masterlist/${propertyId}/bulk`;
  const { body } = await post(authenticationToken, url, {
    propIDList: propertyIds,
  });
  return body;
}
